import Joi from 'joi';

const AUTHORIZED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/jpg'];

/**
 * Custom Joi validation for image File objects.
 * Validates that:
 * - The file exists and has content (size > 0)
 * - The file type is an authorized image type (JPEG/PNG)
 *
 * Files can become stale/empty if the user moves/deletes them after selection.
 */
const imageFile = Joi.any().custom((value: File, helpers) => {
  if (!value || value.size === 0) {
    return helpers.error('file.empty');
  }
  if (!AUTHORIZED_IMAGE_TYPES.includes(value.type)) {
    return helpers.error('file.invalidType');
  }
  return value;
}, 'Image file validation');

const ItemValidationSchema = Joi.object({
  id: Joi.string().uuid().required(),
  front_photo: imageFile.required().messages({
    'file.empty': 'Front photo file is empty or no longer accessible',
    'file.invalidType': 'Front photo must be a JPEG or PNG image',
    'any.required': 'Front photo is required',
  }),
  swatch_photo: imageFile.optional().messages({
    'file.empty': 'Swatch photo file is empty or no longer accessible',
    'file.invalidType': 'Swatch photo must be a JPEG or PNG image',
  }),
  style_number: Joi.string().disallow('').required(),
  division: Joi.string().disallow('').required(),
  department: Joi.string().disallow('').required(),
  category: Joi.string().disallow('').required(),
  class: Joi.string().disallow('').required(),
  jr_cost: Joi.number().min(1).required(),
  plus_cost: Joi.number().min(1).allow(null),
  lead_time_in_weeks: Joi.number().integer().min(1).required(),
  fit_sample: Joi.boolean().required(),
  fashionnova_exclusive: Joi.boolean().required(),
  buyer_pick: Joi.boolean().required(),
  country_of_origin: Joi.string().disallow('').required(),
});

const ItemsValidationSchema = Joi.array().items(ItemValidationSchema);

export { ItemValidationSchema, ItemsValidationSchema };
